import ApiClient from './ApiClient';
import OnPremPORequestObject from '../models/entities/OnPremPORequestObject';
import EscalateType from '../models/interfaces/EscalateType';
import SubmitPORequestObjectOnPrem from '../models/viewModels/OnPremPORequestObjects/SubmitPORequestObjectOnPrem';
import UpdatePortOpeningRequestOnPrem from '../models/viewModels/OnPremPortOpeningRequests/UpdatePortOpeningOnPremRequest';
import RejectionModel from '../models/interfaces/RejectionModel';
import ReviewReason from '../models/interfaces/ReviewReason';
import CancellationReason from '../models/interfaces/CancellationReason';
import ApprovePortOpeningRequestOnPrem from '../models/viewModels/OnPremPortOpeningRequests/ApprovePortOpeningRequestOnPrem';

export default class OnPremObjectRequestService extends ApiClient {

	async getById(id: number) : Promise<OnPremPORequestObject> {
		return this.get<OnPremPORequestObject>(`OnPremObjectRequests/${id}`);
	}

	async getAll() {
		return this.get<OnPremPORequestObject[]>('OnPremObjectRequests');
	}

	async getMyApprovals() {
		return this.get<OnPremPORequestObject[]>('OnPremObjectRequests/myApprovals');
	}
	
	async create(request: SubmitPORequestObjectOnPrem) : Promise<OnPremPORequestObject> {
		return this.post<OnPremPORequestObject>('OnPremObjectRequests', request);
	}
	
	async update(id: number, request: UpdatePortOpeningRequestOnPrem) {
		return this.patch<OnPremPORequestObject>(`OnPremPORequestObject/${id}`, request);
	}
	
	async approve(id: number) {
		return this.patch<OnPremPORequestObject>(`OnPremPORequestObject/${id}/approval`, null);
	}

	async sendToReview(id: number, review: ReviewReason) {
		return this.patch<null>(`OnPremPORequestObject/${id}/review`, review);
	}

	async cancel(id: number, cancellationModel: CancellationReason) {
		return this.patch<OnPremPORequestObject>(
			`OnPremPORequestObject/${id}/cancellation`,
			cancellationModel
		);
	}

	async reject(id: number, rejectionModel: RejectionModel) {
		return this.patch<null>(`OnPremPORequestObject/${id}/rejection`, rejectionModel);
	}

	async doComplete( complete: ApprovePortOpeningRequestOnPrem, id: number) {
		return this.patch<OnPremPORequestObject>(`OnPremPORequestObject/${id}/completion`, complete);
	} 

	async doEscalation( escalate: EscalateType, id: number) {
		return this.patch<OnPremPORequestObject>(`OnPremPORequestObject/${id}/escalate`, escalate);
	}

	async parse(file: File) {
		const formData = new FormData();
		formData.append(file.name, file);
		return this.postFormData('parse/onPremObjects', formData);
	}
}